import Iconify from 'src/components/Iconify';
import { MKT } from '../marketing.design';

export default function MktEmptyState({ icon = 'eva:file-text-outline', title, subtitle, actionLabel, onAction }) {
    return (
        <div className={MKT.emptyState.container}>
            <div className={MKT.emptyState.iconBox}>
                <Iconify icon={icon} width={28} className={MKT.emptyState.icon} />
            </div>
            <h3 className={MKT.emptyState.title}>{title}</h3>
            {subtitle && <p className={MKT.emptyState.subtitle}>{subtitle}</p>}
            {actionLabel && onAction && (
                <span className={MKT.emptyState.action} onClick={onAction}>{actionLabel}</span>
            )}
        </div>
    );
}
